'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  methods: {
    /*
    * @description {Function} 表单校验
    * @param {String} 表单ref对应值
    * @param {Function} 校验成功回调
    * @return {Object} Promise对象
    */
    validate: function validate(ref, callback) {
      var _this = this;

      return _promise2.default.resolve().then(function () {
        return _this.$refs[ref].validate();
      }).then(function (validate) {
        if (!validate) {
          _this.$Message.error(_this.$t('myMessage_zlb.validateMsg'));
          return _promise2.default.resolve(validate);
        }
        callback && callback.apply(_this);
        return _promise2.default.resolve(validate);
      });
    }
  }
};